import React from 'react';
import { BasicVideoHomeCard } from './BasicVideoHomeCard';

export const BasicCardsVideo = (props) => {
    return (
        <div className='row pt-4 pb-5'>
            {props.listings.map(listing => {
                return <BasicVideoHomeCard
                    {...props}
                    key={listing.hpId}
                    listing={listing}
                    isViewed={props.viewedContentIds.includes(listing.hpId)}
                />
            })}

        </div>
    )
}